import styled from 'styled-components';

// @ts-nocheck
var Picture = styled.picture.withConfig({
  displayName: "style__Picture",
  componentId: "sc-10ggsb6-0"
})(["align-items:center;display:inline-flex;justify-content:center;width:100%;img{flex:none;}"]);
var PictureReplacement = styled.div.withConfig({
  displayName: "style__PictureReplacement",
  componentId: "sc-10ggsb6-1"
})(["align-items:center;display:inline-flex;justify-content:center;background-color:var(--color-grey-100);flex-grow:1;height:100%;width:100%;.sg-picture-icon{fill:var(--color-grey-600);}"]);

export { Picture, PictureReplacement };
//# sourceMappingURL=style.js.map
